import { gql } from '@apollo/client';

export const taxPercentageConfigListGql = gql`
  query taxPercentageConfigList(
    $where: TaxPercentageConfigListBaseCriteriaInputDto,
    $filters: TaxPercentageConfigFilterInputDto
  ) {
    taxPercentageConfigList(
        where: $where,
        filters: $filters
    ) {
      items {
        id
        version
        taxType
        label
        displayName
        value
        section
        isArchived
        createdAt
        updatedAt
      },
      meta {
        totalItems
        itemCount
        itemsPerPage
        totalPages
        currentPage
      }
    }
  }
`;